import { Box, BoxProps, Typography } from "@mui/material";
import { MonitoringCardProps } from "src/components/cards/custom/monitoring-card/MonitoringCard";

export type MonitoringCardHeaderProps = Pick<MonitoringCardProps, "topTitle" | "infoIcon"> &
    Partial<Pick<BoxProps, "justifyContent">>;

export const MonitoringCardHeader = ({ topTitle, infoIcon, justifyContent = "space-between" }: MonitoringCardHeaderProps) => (
    <Box display={"flex"} justifyContent={justifyContent}>
        <Typography
            variant={"h4"}
            sx={{
                color: "text.primary",
                textTransform: "none",
            }}
        >
            {topTitle}
        </Typography>
        <Box
            width={24}
            height={24}
            ml="10px"
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            data-testid={`${topTitle}-card-image`}
        >
            {infoIcon}
        </Box>
    </Box>
);
